<section *ngIf="!loggingIn" class="welcome-panel" aria-labelledby="welcome-title">
  <div class="welcome-intro">
    <p class="portal-eyebrow">Health Facility Licensing &amp; Certification</p>
    <h1 id="welcome-title">Health Licensing Administration</h1>
    <p class="welcome-description">Review applications, manage licenses, and coordinate your work with the Oregon Health Authority.</p>
  </div>
  <div class="welcome-access">
    <mat-icon class="access-icon" aria-hidden="true">badge</mat-icon>
    <h2>Staff portal</h2>
    <p>Sign in to access your assigned work and licensing programs.</p>
    <button mat-flat-button color="primary" (click)="login()">Sign in to staff portal <mat-icon iconPositionEnd>arrow_forward</mat-icon></button>
    <p class="access-note" *ngIf="isAAD()">Use your agency account to continue.</p>
  </div>
</section>
<div *ngIf="loggingIn" class="portal-loading" role="status">
  <p>Loading your staff portal…</p>
  <mat-progress-bar mode="indeterminate" aria-label="Loading your staff portal"></mat-progress-bar>
</div>
